/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from 'react';

export function TextInput(props) {
  const { em, data } = props;
  const { parentSize } = em || '';
  const floating = (em && em.floating) || false;
  const groupClass = (floating ? '' : 'row') + ' ' + (em && em.class ? em.class : '');
  const labelClass = floating ? 'label' : `col-sm-${parentSize === 'full' ? '2' : '5'} col-form-label`;
  let inputClass = floating ? '' : `col-sm-${parentSize === 'full' ? '10' : '7'}`;
  inputClass += em && em.align ? ` text-${em.align}` : '';

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const handleDefaultChange = useCallback((e) => {
    console.warn('No change handler', e.target);
  });

  const inputProperty = {};
  if (props.data && em && em.field) {
    inputProperty.value = (props.data && em && em.field && props.data[em.field]) || '';
    inputProperty.onChange = handleDefaultChange;
  }

  if (em.placeholder) {
    inputProperty.placeholder = em.placeholder;
  }

  if (props.onChange) {
    inputProperty.onChange = props.onChange;
  }

  if (props.onBlur) {
    inputProperty.onBlur = props.onBlur;
  }

  return (
    <div className={`form-group ${groupClass}`}>
      <label className={`${labelClass}`}>{em && em.label}</label>
      <input
        type={em.password ? 'password' : 'text'}
        className={`form-control ${inputClass}`}
        name={(em && em.field) || em.name}
        placeholder={em && em.placeholder}
        onKeyDown={em && em.onKeyDown}
        readOnly={em && em.readOnly}
        list={(em && em.datalist) || props.datalist}
        {...inputProperty}
      />
    </div>
  );
}
